import IssuerListContainer from '../helpers/IssuerListContainer';

class DotpayElement extends IssuerListContainer {
    public static type = 'dotpay';
}

export default DotpayElement;
